import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

console.log('%c[RUBBI CRM] v3.6.0 — formatCurrency: regex mode (no Intl)', 'color:#10b981;font-weight:bold;font-size:14px');

// Global error handler: cattura TUTTI gli errori runtime e li salva in localStorage
// Aiuta a diagnosticare crash anche quando l'ErrorBoundary non riesce a catturarli
window.addEventListener('error', (ev) => {
  try {
    const info = {
      type: 'window.error',
      message: ev.message || '',
      filename: ev.filename || '',
      lineno: ev.lineno, colno: ev.colno,
      stack: ev.error?.stack?.split('\n').slice(0, 8).join('\n') || '',
      at: new Date().toISOString(),
    };
    const hist = JSON.parse(localStorage.getItem('rubbi_runtime_errors') || '[]');
    hist.unshift(info);
    localStorage.setItem('rubbi_runtime_errors', JSON.stringify(hist.slice(0, 10)));
  } catch { /* noop */ }
});
window.addEventListener('unhandledrejection', (ev) => {
  try {
    const info = {
      type: 'unhandledrejection',
      reason: String(ev.reason?.message || ev.reason || ''),
      stack: ev.reason?.stack?.split('\n').slice(0, 8).join('\n') || '',
      at: new Date().toISOString(),
    };
    const hist = JSON.parse(localStorage.getItem('rubbi_runtime_errors') || '[]');
    hist.unshift(info);
    localStorage.setItem('rubbi_runtime_errors', JSON.stringify(hist.slice(0, 10)));
  } catch { /* noop */ }
});

// Blocca scroll su input[type="number"] per evitare cambio valore accidentale
document.addEventListener('wheel', function(e) {
  if (e.target && e.target.type === 'number') {
    e.target.blur();
  }
}, { passive: true });

// Nasconde il banner Emergent "Frontend Preview Only" permanentemente
(function emergentBannerKiller() {
  function nuke() {
    document.querySelectorAll('div,section,aside,footer,header,button,p,span,a').forEach(function(el) {
      if (el.closest && el.closest('#root')) return;
      if (el.closest && el.closest('#native-splash')) return;
      var t = (el.textContent || '').toLowerCase();
      if (t.includes('frontend preview') || t.includes('wake up server') || t.includes('wake servers') || t.includes('please wake')) {
        el.style.cssText = 'display:none!important;visibility:hidden!important;height:0!important;overflow:hidden!important;opacity:0!important;pointer-events:none!important;position:absolute!important;top:-9999px!important;';
      }
    });
    document.querySelectorAll('button').forEach(function(btn) {
      if (btn.textContent && btn.textContent.toLowerCase().includes('wake up') && !(btn.closest && btn.closest('#root'))) {
        try { btn.click(); } catch (e) { /* wake button non cliccabile: ignore */ }
        btn.style.cssText = 'display:none!important;';
      }
    });
  }
  nuke();
  setInterval(nuke, 400);
  var obs = new MutationObserver(nuke);
  obs.observe(document.body, { childList: true, subtree: true });
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Registra Service Worker per PWA
if ('serviceWorker' in navigator) {
  // Quando il SW cambia (nuovo deploy), ricarica per usare il codice aggiornato
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!refreshing) {
      refreshing = true;
      window.location.reload();
    }
  });

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js', { updateViaCache: 'none' })
      .then((reg) => {
        console.log('SW registered');
        // Check IMMEDIATO per aggiornamenti all'apertura
        reg.update();
        // Poi check periodico ogni 60 secondi
        setInterval(() => reg.update(), 60000);
      })
      .catch((err) => console.log('SW registration failed:', err));
  });
}
